import React, { useState } from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { useInterval } from "react-use";

export const JoinusBanner = () => {
  const { t } = useTranslation();
  const [element, setElement] = useState(1);
  const bannerPic = [
    // https://authing-files.oss-cn-zhangjiakou.aliyuncs.com/authing-website/joinus-0829-02.png
    {
      url:
        "//authing-files.oss-cn-zhangjiakou.aliyuncs.com/authing-website/joinus-0829-02.png",
    },
    {
      url:
        "//authing-files.oss-cn-zhangjiakou.aliyuncs.com/authing-website/joinus-0829-05.png",
    },
    {
      url:
        "//authing-files.oss-cn-zhangjiakou.aliyuncs.com/authing-website/joinus-0829-03.png",
    },
    {
      url:
        "//authing-files.oss-cn-zhangjiakou.aliyuncs.com/authing-website/joinus-0829-06.png",
    },
    {
      url:
        "//authing-files.oss-cn-zhangjiakou.aliyuncs.com/authing-website/joinus-0829-04.png",
    },
  ];
  const [showCenterBanner, setShowCenterBanner] = useState(false);
  useInterval(() => {
    // if (element < 8) {
    //   setElement(element + 1);
    // } else {
    //   setElement(1);
    // }
    setShowCenterBanner(!showCenterBanner);
  }, 5000);
  const nextFun = () => {
    if (element > 4) {
      setElement(1);
    } else {
      setElement(element + 1);
    }
  };
  const lastFun = () => {
    if (element <= 1) {
      setElement(5);
    } else {
      setElement(element - 1);
    }
  };
  const joinusBannerMobileRender = () => {
    return (
      <div className="joiinus-banner-photos-mobile">
        <div
          className="last-button"
          onClick={() => {
            lastFun();
          }}
        >
          <i
            className="icon authing-icon authing-arrow-down-line"
            style={{
              transform: "rotate(-90deg)",
              display: "inline-block",
            }}
          ></i>
        </div>
        {bannerPic.map((item, index) => {
          if (element === index + 1) {
            return (
              <>
                <div className="item-img">
                  <img src={item.url} alt="authing" />
                </div>
              </>
            );
          } else {
            return null;
          }
        })}
        <div
          className="next-button"
          onClick={() => {
            nextFun();
          }}
        >
          <i
            className="icon authing-icon authing-arrow-down-line"
            style={{
              transform: "rotate(90deg)",
              display: "inline-block",
            }}
          ></i>
        </div>
      </div>
    );
  };
  const joinusBannerPcRender = () => {
    return (
      <div className="joinus-photos">
        <div className="joinus-photos-block">
          <div className="block">
            <img src={bannerPic[1].url} alt="Authing办公环境" />
          </div>
          <div className="block">
            <img src={bannerPic[2].url} alt="Authing福利待遇如何" />
          </div>
        </div>
        <div className="joinus-photos-block">
          {/* <div
            className={
              showCenterBanner
                ? "block block-center"
                : "block block-center visiable"
            }
          >
            <img
              src="//files.authing.co/authing-website/joinus-pic-3.png"
              alt="authing"
            />
          </div>
          <div
            className={
              showCenterBanner
                ? "block block-center visiable"
                : "block block-center"
            }
          >
            <img
              src="//files.authing.co/authing-website/joinus-pic-6.png"
              alt="authing"
            />
          </div> */}
          <div className="block block-center visiable">
            <img src={bannerPic[0].url} alt="Authing公司福利" />
          </div>
        </div>
        <div className="joinus-photos-block">
          <div className="block">
            <img src={bannerPic[3].url} alt="Authing待遇怎么样" />
          </div>
          <div className="block">
            <img src={bannerPic[4].url} alt="Authing待遇如何" />
          </div>
        </div>
      </div>
    );
  };
  return (
    <div>
      <section>
        <div className="joinus-banner-warp">
          <div className="joinus-banner">
            <div className="joinus-banner-text">
              <h3 className="title">{t("joinus.banner.title")}</h3>
              <div className="subtitle">{t("joinus.banner.subtitle")}</div>
            </div>
          </div>
          {joinusBannerPcRender()}
          {joinusBannerMobileRender()}
        </div>
      </section>
    </div>
  );
};
